<template>
  <ArchivedTasks scope="BGYS"></ArchivedTasks>
</template>

<script>
import ArchivedTasks from "./archived-tasks.vue";
export default {
  components: { ArchivedTasks },

  computed: {},
};
</script>
